import TDSFooter from './TDSFooter';

export default TDSFooter;
